import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Currencies } from "../currencies/currencies.entity";

@Entity('exchange_rates')
export class ExchangeRates {
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column('date',{
        name:'effective_from',
        nullable: false
    })
    effectiveFrom: Date

    @Column('decimal',{
        name:'exchange_rate',
        precision:6,
        scale:3,
        nullable:false
    })
    exchangeRate: number

    @Column('boolean',{
        name:'is_active',
        nullable:false,
        default:true
    })
    isActive: boolean

    @CreateDateColumn({
        name:'created_at',
        type:'datetime'
    })
    createdAt: Date

    @Column('varchar',{
        name:'created_user',
        nullable: true
    })
    createdUser: string | null

    @UpdateDateColumn({
        name:'updated_at',
        nullable:true
    })
    updatedAt: Date

    @Column('varchar',{
        name:'updated_user',
        nullable:true
    })
    updatedUser: string | null
    
    @VersionColumn({
        name:'version_flag',
        default:1,
    })
    versionFlag: number

    @ManyToOne(type => Currencies, currency => currency.exchangeInfo,{nullable: false})
    @JoinColumn({name:'currency_id'})
    currencyInfo: Currencies
}